<div class="icon-div"><i class="fa check-circle fa-check-circle" (click)="delete()"></i></div>
<div class="modal-header pt-4 pl-4 mb-0 border-0 modal-text">
</div>
<p class="revert mb-0 modal-text modal-body" [innerHtml]="modcontent"></p>
<div class="modal-body p-0 modal-text">
</div>
<div class="modal-footer mt-0">  
  <button type="button" class="btn btn-success buttonModal" (click)="delete()" >OK</button>
</div>